import React, { Fragment } from "react";
import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { SchemaNonCompliant, ShowTagImage } from "./Schema";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportFraInfoSectionContainer from "../../../../libraries/ReportGenerator/ReportFraInfoSection";
import { EqualContentsRow } from "../../../../libraries/ReportGenerator/EqualContentsRow";

export const NonCompliantLocomotiveReport = (props) => {
  const { reportData } = props;

  let reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(reportData);
  // let removeDuplicates = ReportGroupingUtils.RemoveDuplicateTestCodesFromGroupedReport(reportsByDateAndUser);
  let decodedReports = ReportGroupingUtils.decodeTestsInReportGroups(reportsByDateAndUser);

  return (
    <React.Fragment>
      {decodedReports.map((e, i) => (
        <ReportView key={i} data={e} {...props} />
      ))}
    </React.Fragment>
  );
};

const ReportView = (props) => {
  const { data, title } = props;
  const { decodedData, date, fraHeaderInfo } = data;

  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      <ReportTitleSection title={"Non-Compliant Locomotive Report"} fontSizeOverride={"35px"} />
      <ReportFraInfoSectionContainer {...props} />
      <span className="spacer"></span>
      <Fragment>
        {decodedData.map((e, i) => (
          <div style={{ display: "flex", justifyContent: "center" }} key={i}>
            <EqualContentsRow customStyles={{ width: "-webkit-fill-available" }}>
              <table className="table-bordered">
                {SchemaNonCompliant.map((singleRep, i) => (
                  <ReportTableSectionRenderer section={singleRep} rowsData={e.summary} key={i} />
                ))}
              </table>
              <table className="table-bordered" style={{ maxWidth: "450px" }}>
                <ReportTableSectionRenderer section={ShowTagImage} rowsData={e.summary} />
              </table>
            </EqualContentsRow>
          </div>
        ))}
      </Fragment>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/NonCompliantLocomotiveReport/NonCompliantLocomotiveReport.jsx